import React from "react";
import { connect } from "react-redux";
import { Route, withRouter, Switch } from "react-router-dom";
import cookie from "react-cookies";
import {
  isUserLoggedIn,
  isLogoutSuccess,
} from "./../service/action/audio-track-action";
import {
  LeftNav,
  Landing,
  Login,
  Toastr,
  DashBoard,
  ListernAudio,
  RecordAudio,
  AudioToTrack,
  CreatorTeamDashboard,
  KeywordCreator,
  QADashBoard,
  SuperQADashBoard,
  SuperQATranscript,
  SADashboard,
  AuditKeywordTeam,
  Report,
  QA_AudioDashboard,
  Register,
} from "./index";

class Main extends React.Component {
  componentWillMount() {
    if (cookie.load("username") && cookie.load("fullName")) {
      this.props.isUserLoggedIn(
        cookie.load("fullName"),
        cookie.load("fullName")
      );
      //this.props.isUserLoggedIn('test_7', 'test_7');
    }
  }
  exitApp() {
    this.props.isLogoutSuccess();
    cookie.remove("username");
    cookie.remove("fullName");
    this.props.history.push("/");
  }

  handleNavigation(path) {
    this.props.history.push(`/${path}`);
  }
  componentWillReceiveProps(nextProps) {
    // if(nextProps.userLogin.loggedUser.isVerified){
    // }
  }
  render() {
    const { pathname } = this.props.location;
    return (
      <div>
        <div
          className={`application-page ${
            pathname === "/" || pathname === "/register" ? "no-grid" : "grid"
          }`}
        >
          {pathname === "/" || pathname === "/register" ? null : (
            <LeftNav
              propValue={this.props}
              handleNavigation={(path) => this.handleNavigation(path)}
              exitApp={() => this.exitApp()}
            />
          )}

          {/* <Switch>
                        <Route path='/' exact component={Login} />
                        <Route path='/audio-record' component={RecordAudio} />
                        <Route path='/dashboard' component={Landing} />
                        <Route path='/report' component={DashBoard} />
                        <Route path='/verifyaudio' component={ListernAudio} />
                    </Switch> */}

          <Switch>
            <Route path="/" exact component={Login} />
            <Route path="/register" component={Register} />
            <Route path="/dashboard" component={DashBoard} />
            <Route path="/audio-trans" component={AudioToTrack} />
            <Route path="/audio-record" component={RecordAudio} />
            <Route path="/keyword-generate" component={CreatorTeamDashboard} />
            <Route path="/keyword-create" component={KeywordCreator} />
            <Route path="/report" component={Report} />
            <Route path="/transAduit" component={QADashBoard} />
            <Route path="/audioAduit" component={QA_AudioDashboard} />
            <Route path="/sqa-dasboard" component={SuperQADashBoard} />
            <Route
              path="/super-transcript-audit"
              component={SuperQATranscript}
            />
            <Route path="/sa-dashboard" component={SADashboard} />
            <Route path="/keyword-audit" component={AuditKeywordTeam} />
          </Switch>
          <Toastr />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { AudioToTrackReducer, userLogin } = state;
  return {
    AudioToTrackReducer,
    userLogin,
  };
};

const mapDispatchToProps = (dispatch) => ({
  isUserLoggedIn: (username, password) =>
    dispatch(isUserLoggedIn(username, password)),
  isLogoutSuccess: () => dispatch(isLogoutSuccess()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));
